import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      api.get('/auth/me').then(res => {
        setAdmin(res.data);
        setMustChangePassword(res.data.must_change_password);
      }).catch(() => {
        localStorage.removeItem('admin_token');
        setToken(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = useCallback(async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    localStorage.setItem('admin_token', res.data.token);
    setToken(res.data.token);
    setAdmin(res.data.admin);
    setMustChangePassword(res.data.must_change_password);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('admin_token');
    setToken(null);
    setAdmin(null);
    setMustChangePassword(false);
  }, []);

  const passwordChanged = useCallback(() => {
    setMustChangePassword(false);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, token, loading, mustChangePassword, login, logout, passwordChanged }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
